var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchased(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33616_72996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08447 21.7236C8.61976 21.7236 9.0537 21.2897 9.0537 20.7544C9.0537 20.2191 8.61976 19.7852 8.08447 19.7852C7.54917 19.7852 7.11523 20.2191 7.11523 20.7544C7.11523 21.2897 7.54917 21.7236 8.08447 21.7236Z",
    stroke: "white",
    strokeWidth: 1.93846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7466 21.7236C19.2819 21.7236 19.7158 21.2897 19.7158 20.7544C19.7158 20.2191 19.2819 19.7852 18.7466 19.7852C18.2113 19.7852 17.7773 20.2191 17.7773 20.7544C17.7773 21.2897 18.2113 21.7236 18.7466 21.7236Z",
    stroke: "white",
    strokeWidth: 1.93846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.31836 2.38672H4.25682L6.83497 14.4246C6.92955 14.8654 7.17486 15.2595 7.52866 15.539C7.88247 15.8186 8.32265 15.966 8.77344 15.9559H18.2525C18.6937 15.9552 19.1214 15.8041 19.465 15.5274C19.8087 15.2507 20.0477 14.8651 20.1425 14.4343L21.7417 7.23287",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9301 2.7998L12.3301 9.39981L9.33008 6.3998",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33616_72996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2615,
    height: 23.2615,
    fill: "white",
    transform: "translate(0.330078 0.400391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchased);
export default __webpack_public_path__ + "static/media/purchased.46c12e578a1e2eef2dff8bfae2d5a003.svg";
export { ForwardRef as ReactComponent };